module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp12_8004.21b04d55.png";